import React, {useContext} from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {Button} from '@igp/shared/components/button';
import {KeyValueCell, KeyValueColumn, KeyValueTable} from '@igp/shared/components/key-value-table';
import {ModalContext, ModalFooter} from '@igp/shared/components/modal';
import {formatTimestamp} from '@igp/shared/utils';

import {useRepaymentLogActions} from '../hooks';
import type {RepaymentLogViewModel} from '../types';

const localized = defineMessages({
    repaymentDate: {
        id: 'RemoveRepaymentLogConfirmationModal_repaymentDate',
        defaultMessage: 'Repayment Date',
    },
    masterAgentId: {
        id: 'RemoveRepaymentLogConfirmationModal_masterAgentId',
        defaultMessage: 'Master Agent ID',
    },
    fromAgentId: {
        id: 'RemoveRepaymentLogConfirmationModal_fromAgentId',
        defaultMessage: 'From Agent ID',
    },
    repaymentAmount: {
        id: 'RemoveRepaymentLogConfirmationModal_repaymentAmount',
        defaultMessage: 'Repayment Amount',
    },
    submit: {
        id: 'RemoveRepaymentLogConfirmationModal_submit',
        defaultMessage: 'Submit',
    },
    cancel: {
        id: 'RemoveRepaymentLogConfirmationModal_cancel',
        defaultMessage: 'Cancel',
    },
});

type RemoveRepaymentLogConfirmationModalProps = {
    log: RepaymentLogViewModel;
};

export function RemoveRepaymentLogConfirmationModal({log}: RemoveRepaymentLogConfirmationModalProps) {
    const {formatMessage} = useIntl();
    const {closeModal} = useContext(ModalContext);
    const {remove, isRemoveInProgress} = useRepaymentLogActions();
    function handleSubmitClick() {
        remove(log.repaymentId);
        closeModal();
    }
    return (
        <>
            <KeyValueTable mode="card">
                <KeyValueColumn>
                    <KeyValueCell title={formatMessage(localized.repaymentDate)}>{formatTimestamp(log.repaymentDate, 'date')}</KeyValueCell>
                    <KeyValueCell title={formatMessage(localized.masterAgentId)}>{log.masterAgentUid}</KeyValueCell>
                    <KeyValueCell title={formatMessage(localized.fromAgentId)}>{log.fromAgentUid}</KeyValueCell>
                    <KeyValueCell title={formatMessage(localized.repaymentAmount)}>{log.repaymentAmount?.toFixed(2)}</KeyValueCell>
                </KeyValueColumn>
            </KeyValueTable>
            <ModalFooter>
                <Button type="button" onClick={handleSubmitClick} label={localized.submit} color="primary" disabled={isRemoveInProgress} />
                <Button type="button" onClick={closeModal} label={localized.cancel} />
            </ModalFooter>
        </>
    );
}
